export const userManualTheme = {
  sectionItem: {
    bg: 'palette.gradients.manualItemBg',
    borderRadius: '12px',
    content: 'palette.white',
    footer: 'palette.surface.4',
  },
};
